// SignUp
import { Footer } from '../components/footer/Footer';
import '../styles/SignInUpPage.scss';


function NotFoundPage() {
  return (
    <div id="404pageContainer" className="pageContainer" style={{color:"#fff"}}>
      <div id="orientationContainer" className="orientationContainer">
        <div className="notFoundContent">

        {/* Title and Subtitle */}
        <div className="signInTitleBlock">
            <h2 className="title">Page Not Found</h2>
            <hr/>
            <h3 className="subtitle">This page does not exist or is still under development</h3>
            <p className="edition">Try back later!</p>
        </div>
        <div style={{width:"100vw", textAlign:"center"}}>
        <br/>
          <h1>Under Construction</h1>
          <p>The page you're looking for doesn't exist yet.</p>


        {/* Buttons */}
        <div className="buttonContainer" style={{display: "block"}}>
            <button 
            className="signInButton signInColor" 
            onClick={() => window.history.back()}
            >
            Go Back
            </button>
            <br/><br/><br/><br/><br/>
            <hr/>
          </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default NotFoundPage;
